import axios from "axios"
import baseUrl from "./base"

const paketApi = {
  fetchBerita: async (token, data) => {
    return await axios.get(`${baseUrl}/api/berita/get`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showBerita: async (slug) => {
    return await axios.get(`${baseUrl}/api/berita/${slug}`)
  },
  showBeritaByAdmin: async (token, slug) => {
    return await axios.get(`${baseUrl}/api/berita/${slug}/showByAdmin`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchBeritaPin: async (data) => {
    return await axios.get(`${baseUrl}/api/berita/getPin`,
      { params: data }
    )
  },
  fetchBeritaHomepage: async (data) => {
    return await axios.get(`${baseUrl}/api/berita/getHomepage`,
      { params: data }
    )
  },
  fetchBeritaHeadline: async (data) => {
    return await axios.get(`${baseUrl}/api/berita/getHeadline`,
      { params: data }
    )
  },
  fetchAllBerita: async (data) => {
    return await axios.get(`${baseUrl}/api/berita/getAllBerita`,
      { params: data }
    )
  },
  storeBerita: async (token, data) => {
    return await axios.post(`${baseUrl}/api/berita/store`, data,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    )
  },
  updateBerita: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/berita/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    )
  },
  deleteBerita: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/berita/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  }
}

export default paketApi